'use strict';
/* jslint browserify:true, browser:true, devel:true */

import leafletStyles from 'leaflet/dist/leaflet.css';
import mapStyles from 'stylus/map.styl';

import $ from 'jquery';
import L from 'leaflet';
import { Signal } from 'signals';

import ArchiveMap from './ArchiveMap';
import MapTooltip from './tooltip/MapTooltip';
import mapOpts from './mapOpts';
import mapURL from './mapURL.txt';

export default class Map {

  constructor($container, archive, config) {
    this._$container = $container;
    this._config = config;
    this._archive = archive;

    this.updated = new Signal();

    this._$map = $('<div id="map"></div>');
    this._$container.append(this._$map);
    this._setUp();
  }

  _setUp() {
    mapOpts.extension = L.Browser.retina ? '@2x' : '';
    this._lmap = L.map(this._$map[0].id).setView([45.0667, 7.7000], 14);
    this._lmap.addLayer(L.tileLayer(mapURL, mapOpts));
    this._tooltip = new MapTooltip(this._lmap, this._$container);
    this._archiveMap = new ArchiveMap(this._lmap, this._archive, this._tooltip);
    this._archiveMap.updated.add(() => this.updated.dispatch());
  }

  hideTooltip() {
    // not needed for leaflet map
  }

}



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/map/Map.es6
 **/